import { render, staticRenderFns } from "./LabelCategorySettingsTable.vue?vue&type=template&id=006a8010&"
import script from "./LabelCategorySettingsTable.vue?vue&type=script&lang=js&"
export * from "./LabelCategorySettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports